
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { BookingItemProps } from ".";
import { loading, endLoading } from "store/booking";

interface ApiBookingRemoveInputProps {
    ids: number[]
}

type ApiBookingRemoveOutputProps = OutputBaseProps<{ item: BookingItemProps; }>

export const apiBookingRemove = async (data: ApiBookingRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiBookingRemoveOutputProps>("/api/booking/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};